import Smart from 'hocs/smart';
import View from './organisationAccess-view';

export default Smart(
  View,
  state => ({
  }),
  ac => ({})
);
